import { useSelector } from 'react-redux';
import { selectFiles } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import ClientInputNotes from './client-input-notes'
import ClientSupportingDocuments from './client-supporting-documents'

export default function ThirdStep() {

    const files = useSelector(selectFiles);
    
    return (
        <div className="grid grid-cols-1 gap-4">
            {/* SUPPORTING DOCUMENTS */}
            <div className="min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <ClientSupportingDocuments
                    files={files}
                />
            </div>

            {/* NOTES */}
            <div className="min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <ClientInputNotes />
            </div>
        </div>
    )
}
